export default __webpack_public_path__ + "static/media/kuchyn.d0b5ec6e.jpeg";